// removes query params and return pathName
export function getPathNamefromAsPath(asPath) {
  return asPath.indexOf("?") === -1
    ? asPath
    : asPath.substring(0, asPath.indexOf("?"));
}
